import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import {
  Box,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import PeopleIcon from '@mui/icons-material/People'
import ModelIcon from '@mui/icons-material/Category'
import SetIcon from '@mui/icons-material/CollectionsBookmark'
import BrushIcon from '@mui/icons-material/Brush'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import DashboardIcon from '@mui/icons-material/Segment'
import ViewModuleIcon from '@mui/icons-material/ViewModule'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import ExploreIcon from '@mui/icons-material/Explore'
import ArticleIcon from '@mui/icons-material/Article'
import SettingsIcon from '@mui/icons-material/Settings'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'

const SideMenu = () => {
  const [collapsed, setCollapsed] = useState(false)

  const menuItems = [
    {to:'/', label: 'Dashboard', icon:DashboardIcon },
    { to: '/users', label: 'Users', icon: PeopleIcon },
    { to: '/models', label: 'Models', icon: ModelIcon },
    { to: '/sets', label: 'Sets', icon: SetIcon },
    { to: '/styles', label: 'Styles', icon: BrushIcon },
    { to: '/prompts', label: 'Prompts', icon: ChatBubbleOutlineIcon },
    { to: '/sections', label: 'Sections', icon: ViewModuleIcon },
    { to: '/tags', label: 'Tags', icon: LocalOfferIcon },
    { to: '/explore-management', label: 'Explore Management', icon: ExploreIcon },
    { to: '/revenuecat-products', label: 'RevenueCat Products', icon: MonetizationOnIcon },
    { to: '/system', label: 'System Config', icon: SettingsIcon },
  ]

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: collapsed ? '70px' : '160px',
        bgcolor: '#212529',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: 2,
        transition: 'width 0.3s ease'
      }}
    >
      <Box
      sx={{
        flexGrow: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        py:5
      }}>
        {menuItems.map(({ to, label, icon: Icon }) => (
          <Tooltip
            key={to}
            title={collapsed ? label : ''}
            arrow
            placement="right"
            componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '16px',
                  bgcolor: '#fff',
                  color: '#1e1e2f'
                }
              },
              arrow: { sx: { color: '#fff' } }
            }}
          >
            <Box
            component={NavLink}
            to={to}
            key={to}
            sx={{
              fontSize:'24px',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              px: 2,
              py: 1,
              mb: 1,
              borderRadius: 1,
              textDecoration: 'none',
              width: '100%',
              color: '#fff',
              border: '1px solid transparent',
              transition: 'all 0.3s ease',

              '&.active': {
                backgroundColor: '#fff',
                color: '#212529',
              },
              '&:hover': {
                borderColor: '#fff'
              }
            }}
          >
          <Box sx={{ width: 24, display: 'flex', justifyContent: 'center' }}>
            <Icon fontSize="medium" />
        </Box>
          {!collapsed && (
            <Typography variant="body1">{label}</Typography>
          )}
        </Box>
        </Tooltip>
        ))}
      </Box>

      {/* toggle button */}
      <IconButton
        onClick={() => setCollapsed(!collapsed)}
        sx={{
          mb: 2,
          width: 45,
          height: 45,
          border: '1px solid white',
          color: 'white',
          '&:hover': {
            bgcolor: 'white',
            color: '#212529'
          }
        }}
        title={collapsed ? 'Open Menu' : 'Collapse Menu'}
      >
        <MenuIcon fontSize="medium" />
      </IconButton>
    </Box>
  )
}


export default SideMenu

